module.exports = __webpack_public_path__ + "img/Ranking-desktop.0ffe286d.webp";